import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardsCard = _resolveComponent("DashboardsCard")!
  const _component_RegionDashboardsRatingList = _resolveComponent("RegionDashboardsRatingList")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingCards, (item, index) => {
    return (_openBlock(), _createElementBlock("div", { key: item }, [
      _createVNode(_component_DashboardsCard, {
        card: item,
        year: _ctx.year,
        isShowAPPG: _ctx.isShowAPPG,
        variant: "button",
        indicatorsColor: "blue",
        isClickable: index === 0,
        onClick: ($event: any) => (_ctx.selectCard(item, +index)),
        isLoading: _ctx.isLoadingCards,
        isAmountDifferenceInverted: ""
      }, null, 8, ["card", "year", "isShowAPPG", "isClickable", "onClick", "isLoading"]),
      _createVNode(_component_ModalComponent, {
        title: _ctx.currentCard?.title,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false)),
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
        contentClass: "modal--new"
      }, {
        default: _withCtx(() => [
          (_ctx.filter?.regionRfId)
            ? (_openBlock(), _createBlock(_component_RegionDashboardsRatingList, {
                key: 0,
                ratingList: _ctx.getRatingListCache,
                currentItemId: _ctx.filter.regionRfId,
                onSelect: _ctx.selectCard,
                isLoading: _ctx.isLoadingList,
                placeMode: "soft"
              }, null, 8, ["ratingList", "currentItemId", "onSelect", "isLoading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]))
  }), 128))
}